<template>
  <div>
    <!-- <el-button  class="lookUp" icon="el-icon-document-checked" type="danger" @click="goToProjectCheck">查看验收报告</el-button> -->
    <el-button class="goBack" @click="goBack">返回</el-button>
    <div class="projectInfo">
      <div class="blockHeader">
        <div class="redBlock"></div>
        <div class="headerText">{{ projectObj.name }}工程详情</div>
      </div>
      <div class="blockContent">
        <div class="blockItem">
          <div class="item_type1">
            <div class="itemLeft">工程类型</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="projectObj.projectType"></el-input>
              <span v-if="!isLook" class="infoShow">{{ projectObj.projectType == 0 ? '道路施工' : '土方压实' }}</span>
            </div>
          </div>
          <div class="item_type1">
            <div class="itemLeft">工程地址</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="projectObj.address"></el-input>
              <span v-if="!isLook" class="infoShow">{{ projectObj.address }}</span>
            </div>
          </div>
          <div class="item_type1">
            <div class="itemLeft">工程创建时间</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="projectObj.createTime"></el-input>
              <span v-if="!isLook" class="infoShow">{{ projectObj.createTime }}</span>
            </div>
          </div>
          <div class="item_type1">
            <div class="itemLeft">工程进度</div>
            <div class="itemRight">
              <span v-if="!isLook" class="infoShow">{{ projectObj.pecent }}</span>
            </div>
          </div>
        </div>
        <div class="blockItem">
          <div class="item_type1">
            <div class="itemLeft">工程开工时间</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="projectObj.startTime"></el-input>
              <span v-if="!isLook" class="infoShow">{{ projectObj.startTime }}</span>
            </div>
          </div>
          <div class="item_type1">
            <div class="itemLeft">工程计划竣工时间</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="projectObj.planEndTime"></el-input>
              <span v-if="!isLook" class="infoShow">{{ projectObj.planEndTime }}</span>
            </div>
          </div>
          <div class="item_type1">
            <div class="itemLeft">工程剩余时间</div>
            <div class="itemRight">{{ projectObj.surplus }}</div>
          </div>
          <div class="item_type1">
            <div class="itemLeft">工程实际完成时间</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="projectObj.endTime"></el-input>
              <span v-if="!isLook" class="infoShow">{{ projectObj.endTime }}</span>
            </div>
          </div>
        </div>
        <div class="blockItem">
          <div class="item_type1">
            <div class="itemLeft">施工单位</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="projectObj.consUnit"></el-input>
              <span v-if="!isLook" class="infoShow">{{ projectObj.consUnit }}</span>
            </div>
          </div>
          <div class="item_type1">
            <div class="itemLeft">监理单位</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="projectObj.supervisor"></el-input>
              <span v-if="!isLook" class="infoShow">{{ projectObj.supervisor }}</span>
            </div>
          </div>
          <div class="item_type1">
            <div class="itemLeft">工程负责人</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="projectObj.principal"></el-input>
              <span v-if="!isLook" class="infoShow">{{ projectObj.principal }}</span>
            </div>
          </div>
          <div class="item_type1">
            <div class="itemLeft">工程联系电话</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="projectObj.principalPhone"></el-input>
              <span v-if="!isLook" class="infoShow">{{ projectObj.principalPhone }}</span>
            </div>
          </div>
        </div>
        <div class="blockItem">
          <div class="item_type2">
            <div class="itemLeft">已建立作业</div>
            <div class="itemRight">
              <span v-if="!isLook" class="infoShow">{{ projectObj.workListStr }}</span>
            </div>
          </div>
          <div class="item_type2">
            <div class="itemLeft">已完成作业</div>
            <div class="itemRight">
              <span v-if="!isLook" class="infoShow">{{ projectObj.workListed }}</span>
            </div>
          </div>

        </div>
        <div class="blockItem">
          <div class="item_type2">
            <div class="itemLeft">已关联设备</div>
            <div class="itemRight">
              <span v-if="!isLook" class="infoShow">{{ projectObj.equipCodeList }}</span>
            </div>
          </div>
          <div class="item_type2">
            <div class="itemLeft">已关联标段</div>
            <div class="itemRight"><span v-if="!isLook" class="infoShow">{{ projectObj.sectionNameListStr }}</span></div>
          </div>
        </div>
      </div>
    </div>

    <div class="projectInfo">
      <div class="blockHeader">
        <div class="redBlock"></div>
        <div class="headerText">作业列表</div>
        <div class="workListTable" id="nav">
          <span class="workItem" v-for="(item, index) in workList" :key="item.id"
            :class="{ activeWorkItem: index == workIndex }">
            <span class="workItemText"
              @click="getWorkItemInfo(item.id, index, item.createProcess)">{{ item.createProcess == 0 ? item.name : item.name + '(创建中)' }}</span>
          </span>
        </div>
        <el-button class="addBtn" icon="el-icon-plus" type="danger" @click="goToNewJob"
          v-if="sourceTypeShow">新建</el-button>
        <el-button class="copyBtn" type="warning" plain v-if="sourceTypeShow" @click="goToCopyJob">复制</el-button>
        <el-button class="editBtn" type="warning" plain @click="goToEditJob" v-if="sourceTypeShow">修改</el-button>
        <el-button class="deleteBtn" type="info" plain v-if="sourceTypeShow" @click="goToDeleteJob">删除</el-button>
      </div>
      <div class="line" style="height:1px;background-color:#E1E1E1;width:97.7%;margin:0 auto"></div>
      <div class="blockContent" style="margin-top: 14px">
        <div class="blockItem">
          <div class="item_type1">
            <div class="itemLeft">作业类型</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.workTypeText"></el-input>
              <span v-if="!isLook" class="infoShow">{{ workObj.workTypeText }}</span>
            </div>
          </div>
          <div class="item_type1">
            <div class="itemLeft">作业标段</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.sectionName"></el-input>
              <span v-if="!isLook" class="infoShow">{{ workObj.sectionName }}</span>
            </div>
          </div>
          <div class="item_type2">
            <div class="itemLeft">作业设备</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.equipNames"></el-input>
              <span v-if="!isLook" class="infoShow">{{ workObj.equipNames }}</span>
            </div>
          </div>
        </div>
        <div class="blockItem">
          <!-- <div class="item_type1">
            <div class="itemLeft">作业名称</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.name"></el-input>
              <span v-if="!isLook" class="infoShow">{{workObj.name}}</span>
            </div>
          </div>
          <div class="item_type1">
            <div class="itemLeft">所属工程</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.projectName"></el-input>
              <span v-if="!isLook" class="infoShow">{{workObj.projectName}}</span>
            </div>
          </div> -->
          <div class="item_type1">
            <div class="itemLeft">作业创建时间</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.createTime"></el-input>
              <span v-if="!isLook" class="infoShow">{{ workObj.createTime }}</span>
            </div>
          </div>
          <div class="item_type1">
            <div class="itemLeft">作业开工时间</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.startTime"></el-input>
              <span v-if="!isLook" class="infoShow">{{ workObj.startTime }}</span>
            </div>
          </div>
          <div class="item_type1">
            <div class="itemLeft">作业计划竣工时间</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.planEndTime"></el-input>
              <span v-if="!isLook" class="infoShow">{{ workObj.planEndTime }}</span>
            </div>
          </div>
          <div class="item_type1">
            <div class="itemLeft">作业实际完成时间</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.endTime"></el-input>
              <span v-if="!isLook" class="infoShow">{{ workObj.endTime }}</span>
            </div>
          </div>
        </div>
        <!-- <div class="blockItem">
          
          <div class="item_type1">
            <div class="itemLeft">作业剩余时间</div>
            <div class="itemRight">
              <span v-if="!isLook" class="infoShow">{{workObj.surplus}}</span>
            </div>
          </div>
          
        </div> -->
        <div class="blockItem">
          <div class="item_type1">
            <div class="itemLeft">施工单位</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.consUnit"></el-input>
              <span v-if="!isLook" class="infoShow">{{ workObj.consUnit }}</span>
            </div>
          </div>
          <div class="item_type1">
            <div class="itemLeft">监理单位</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.supervisor"></el-input>
              <span v-if="!isLook" class="infoShow">{{ workObj.supervisor }}</span>
            </div>
          </div>
          <div class="item_type1">
            <div class="itemLeft">作业负责人</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.principal"></el-input>
              <span v-if="!isLook" class="infoShow">{{ workObj.principal }}</span>
            </div>
          </div>
          <div class="item_type1">
            <div class="itemLeft">作业联系电话</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.principalPhone"></el-input>
              <span v-if="!isLook" class="infoShow">{{ workObj.principalPhone }}</span>
            </div>
          </div>
          <!-- <div class="item_type1">
            <div class="itemLeft">作业进度</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.workProcess"></el-input>
              <span v-if="!isLook" class="infoShow">{{workObj.workProcess==null?'-':(workObj.workProcess*100).toFixed(2)+' %' }}</span>
            </div>
          </div> -->
        </div>

        <div class="blockItem">
          <!-- <div class="item_type1">
            <div class="itemLeft">作业状态</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.status"></el-input>
              <span v-if="!isLook" class="infoShow">{{workObj.statusText}}</span>
            </div>
          </div> -->
          <div class="item_type1" v-if="workObj.workType == 3 || workObj.workType == 4">
            <div class="itemLeft">总作业里程</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.sumMileage"></el-input>
              <span v-if="!isLook" class="infoShow">{{ workObj.sumMileage == null ? '-' : workObj.sumMileage + ' km' }}</span>
            </div>
          </div>
          <div class="item_type1" v-if="workObj.workType == 3 || workObj.workType == 4">
            <div class="itemLeft">已完成里程</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.curMileage"></el-input>
              <span v-if="!isLook" class="infoShow">{{ workObj.curMileage == null ? '-' : workObj.curMileage + ' km' }}</span>
            </div>
          </div>
          <div class="item_type1" v-if="workObj.workType == 1 || workObj.workType == 2">
            <div class="itemLeft">总作业面积</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.sumArea"></el-input>
              <span v-if="!isLook" class="infoShow">{{ workObj.sumArea == null ? '-' : workObj.sumArea + ' m²' }}</span>
            </div>
          </div>
          <div class="item_type1" v-if="workObj.workType == 1 || workObj.workType == 2">
            <div class="itemLeft">已完成面积</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.curArea"></el-input>
              <span v-if="!isLook" class="infoShow">{{ workObj.curArea == null ? '-' : workObj.curArea + ' m²' }}</span>
            </div>
          </div>
          <div class="item_type1" v-if="workObj.workType == 3 || workObj.workType == 4">
            <div class="itemLeft">作业起始桩号</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.startMileage"></el-input>
              <span v-if="!isLook"
                class="infoShow">{{ workObj.startMileage == null ? '-' : turnMileage(workObj.startMileage) }}</span>
            </div>
          </div>
          <div class="item_type1" v-if="workObj.workType == 3 || workObj.workType == 4">
            <div class="itemLeft">作业结束桩号</div>
            <div class="itemRight">
              <el-input v-if="isLook" class="infoShow" v-model="workObj.endMileage"></el-input>
              <span v-if="!isLook"
                class="infoShow">{{ workObj.endMileage == null ? '-' : turnMileage(workObj.endMileage) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="parameterContent" v-if="workSetInfoShow && (workType == 4 || workType == 3)">
        <Parameter :isLook="isLook" :workSetInfo="workSetInfo_show"></Parameter>
      </div>
      <div class="parameterContent" v-if="workSetInfoShow && (workType == 2 || workType == 1)">
        <Parameter1 :isLook="isLook" :workSetInfo="workSetInfo_show"></Parameter1>
      </div>
    </div>


  </div>
</template>

<script>
import { getEnginInfo, getWorkInfo, deleteWork, getEquipsList } from "../../utils/api"
import { getNowDataNum } from "../../utils/commons";
import Parameter from '../../components/engineering/parameter'
import Parameter1 from '../../components/engineering/parameter1'
export default {
  name: 'app',
  data() {
    return {
      arrowList: [
        {
          name: '工程中心',
          path: '/transfer/engineeringCenter'
        },
        //   {
        //      name: '工程管理',
        //       path: '/transfer/engineeringList'
        //   },
        {
          name: '工程详情',
          path: '/transfer/engineeringInfo'
        },
      ],
      projectId: '',
      projectObj: {},
      workObj: {},
      isLook: false,
      workSetInfoShow: false,
      workSetInfo: '',
      rollType: {
        "0": "静压",
        "1": "小震",
        "2": "大震",
      },
      workList: [],
      workIndex: 0,
      workType: 0,
      workCheckId: '',
      workIdCheck: '',
      workInfoSet_show: '',
      equipmentList: [],
      sourceTypeShow: false,
      workInfoSet: '',
      createProcess: '',
    }
  },
  computed: {
    turnMileage() {
      return (num) => {
        let a = parseInt(num / 1000)
        let b = (num - a * 1000).toFixed(1)
        return 'K' + a + '+' + b
      }
    }
  },
  created() {

  },
  mounted() {
    this.$store.commit('setArrowList', this.arrowList)

    if (this.$route.params.id) {
      this.projectId = this.$route.params.id
      localStorage.setItem('projectSetId', this.$route.params.id)
    } else {
      this.projectId = localStorage.getItem('projectSetId')
    }

    let params = {
      id: this.projectId
    }
    getEquipsList({ pageSize: 10000 }).then(res => {
      this.equipmentList = res.data.content.info.list
      this.getProjectInfo(params)
    })
    this.scrollInit()

  },
  methods: {
    goToProjectCheck() {
      this.$router.push({ path: '/transfer/projectCheck', query: { projectId: this.projectId } });
    },
    getWorkItemInfo: function (data, index, step) {
      this.workIndex = index;
      this.workIdCheck = data
      this.workCheckId = data
      this.createProcess = step
      let paramsData = { id: data }
      this.getWorkInfoFun(paramsData)
    },
    scrollInit() {
      // 获取要绑定事件的元素
      const scrollDiv = document.getElementById("nav");
      // document.addEventListener('DOMMouseScroll', handler, false)
      // 添加滚轮滚动监听事件，一般是用下面的方法，上面的是火狐的写法
      scrollDiv.addEventListener('mousewheel', handler, false)
      // 滚动事件的出来函数
      function handler(event) {
        // 获取滚动方向
        const detail = event.wheelDelta || event.detail;
        // 定义滚动方向，其实也可以在赋值的时候写
        const moveForwardStep = 1;
        const moveBackStep = -1;
        // 定义滚动距离
        let step = 0;
        // 判断滚动方向,这里的100可以改，代表滚动幅度，也就是说滚动幅度是自定义的
        if (detail < 0) {
          step = moveForwardStep * 100;
        } else {
          step = moveBackStep * 100;
        }
        // 对需要滚动的元素进行滚动操作
        scrollDiv.scrollLeft += step;
        event.preventDefault()
      }
    },
    goBack: function () {
      this.$router.push({ name: 'EngineeringCenter' });
    },
    goToNewJob: function () {
      this.$router.push({ name: 'NewJob', params: { id: this.projectId, workNameList: this.workNameList, projectType: this.projectObj.projectType, type: "new" } });
    },
    goToCopyJob: function () {
      this.$router.push({ name: 'NewJob', params: { id: this.projectId, workNameList: this.workNameList, workInfoSet: this.workInfoSet, projectType: this.projectObj.projectType, type: "copy" } });
    },
    goToEditJob: function () {
      this.$router.push({ name: 'NewJob', params: { id: this.projectId, workNameList: this.workNameList, workId: this.workIdCheck, workInfoSet: this.workInfoSet, projectType: this.projectObj.projectType, type: "edit", createProcess: this.createProcess } });
    },
    goToDeleteJob: function () {
      this.$confirm("确认对所选作业进行删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true,
      }).then(() => {
        let params = {
          workId: this.workIdCheck
        }
        deleteWork(params).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: "删除成功!",
              type: "success"
            })
            this.getProjectInfo({ id: this.projectId })
            this.workIndex = 0
          }

        }).catch(() => {
          // this.$message({
          //   message: "删除失败!",
          //   type: "error"
          // });
          this.getProjectInfo({ id: this.projectId })
          this.workIndex = 0
        })
      });
    },
    getProjectInfo: function (params) {
      getEnginInfo(params).then(res => {
        console.log(res)
        this.projectObj = res.data.content.info
        this.projectObj.pecent = (this.projectObj.process * 100).toFixed(2) + ' %'
        this.workIdCheck = res.data.content.info.workInfos[0] ? res.data.content.info.workInfos[0].id : ''
        this.createProcess = this.projectObj.workInfos[0] ? this.projectObj.workInfos[0].createProcess : ''
        // console.log(this.projectObj.curMileage)
        // console.log(this.projectObj.sumMileage)
        let arr = this.projectObj.equipCodeList
        for (let i = 0; i < this.equipmentList.length; i++) {
          for (let j = 0; j < arr.length; j++) {
            if (this.equipmentList[i].code == arr[j]) {
              arr[j] = this.equipmentList[i].name
            } else if (this.equipmentList[i].name == arr[j]) {
              arr[j] = this.equipmentList[i].name
            }
          }
        }
        if (res.data.content.info.sourceType == 0) {
          // 来自本地平台
          this.sourceTypeShow = false
        } else {
          this.sourceTypeShow = true
        }
        this.projectObj.equipCodeList = arr
        console.log(arr, 'arr')
        this.projectObj.equipCodeList = this.projectObj.equipCodeList.join(",")
        this.projectObj.surplus = getNowDataNum(this.projectObj.planEndTime)
        this.workList = res.data.content.info.workInfos
        this.workCheckId = this.projectObj.workInfos.length > 0 ? this.projectObj.workInfos[0].id : ''
        let paramsData = {
          id: this.projectObj.workInfos.length > 0 ? this.projectObj.workInfos[0].id : ''
        }
        // 已建立作业
        let workListStr = []
        // 已完成
        let workListed = []
        for (let i = 0; i < this.workList.length; i++) {
          // 已建立
          if (this.workList[i].createProcess == 0) {
            workListStr.push(this.workList[i].name)
          }
          // 已完成
          if (this.workList[i].status == 2) {
            workListed.push(this.workList[i].name)
          }
        }
        this.projectObj.workListStr = workListStr.join(",")
        this.projectObj.workListed = workListed.join(",")
        this.projectObj.sectionNameListStr = this.projectObj.sectionNameList.join(",")
        if (paramsData.id != 0) {
          this.getWorkInfoFun(paramsData)
        }

      })
    },
    getWorkInfoFun: function (params) {
      getWorkInfo(params).then(res => {
        //console.log(res)
        // this.workObj = res.data.content.info
        let getInfo = res.data.content.info
        this.workInfoSet = res.data.content.info;
        this.workType = getInfo.workType
        let workTypeList = this.$store.state.workTypeList
        let statusList = this.$store.state.statusList
        if (getInfo) {
          getInfo.workTypeText = workTypeList[getInfo.workType]
          getInfo.statusText = statusList[getInfo.status]
          //标准道路
          getInfo.pecent = getInfo.sumMileage == 0 || getInfo.curMileage == 0 ? 0 : ((getInfo.curMileage / getInfo.sumMileage) * 100).toFixed(1) + '%'
          getInfo.surplus = getNowDataNum(getInfo.planEndTime)
          getInfo.equipCodeList = getInfo.equipCodeList.join(",")
          if (this.workType == 4) {
            if (getInfo.paramInfo) {
              getInfo.paramInfo.equipCodePaverStr = getInfo.equipCodePaver.join("、")
              getInfo.paramInfo.equipCodeRoller1ndStr = getInfo.equipCodeRoller1st.join("、")
              getInfo.paramInfo.equipCodeRoller2ndStr = getInfo.equipCodeRoller2nd.join("、")
              getInfo.paramInfo.equipCodeRoller3ndStr = getInfo.equipCodeRoller3rd.join("、")
            }

          }
          this.workObj = getInfo
          console.log(this.workObj)
          if (getInfo.paramInfo == '') {
            return
          } else {
            if (getInfo.paramInfo) {
              let setInfo = getInfo.paramInfo
              setInfo.setCode = 'init'
              this.workSetInfo = setInfo
              this.workSetInfo.equipCheckStr = getInfo.equipCodeList

              this.workObj = JSON.parse(JSON.stringify(getInfo))
              let getArr = this.workObj.equipCodeList.split(",")
              let arr = []
              for (let i = 0; i < this.equipmentList.length; i++) {
                for (let j = 0; j < getArr.length; j++) {
                  if (this.equipmentList[i].code == getArr[j]) {
                    arr[j] = this.equipmentList[i].name
                  } else if (this.equipmentList[i].name == getArr[j]) {
                    arr[j] = this.equipmentList[i].name
                  }
                }
              }
              let arr1 = [], arr2 = [], arr3 = [], arr4 = []
              for (let i = 0; i < this.equipmentList.length; i++) {
                for (let j = 0; j < getInfo.equipCodePaver.length; j++) {
                  if (this.equipmentList[i].code == getInfo.equipCodePaver[j]) {
                    arr1[j] = this.equipmentList[i].name
                  } else if (this.equipmentList[i].name == getInfo.equipCodePaver[j]) {
                    arr1[j] = this.equipmentList[i].name
                  }
                }
                for (let j = 0; j < getInfo.equipCodeRoller1st.length; j++) {
                  if (this.equipmentList[i].code == getInfo.equipCodeRoller1st[j]) {
                    arr2[j] = this.equipmentList[i].name
                  } else if (this.equipmentList[i].name == getInfo.equipCodeRoller1st[j]) {
                    arr2[j] = this.equipmentList[i].name
                  }
                }
                for (let j = 0; j < getInfo.equipCodeRoller2nd.length; j++) {
                  if (this.equipmentList[i].code == getInfo.equipCodeRoller2nd[j]) {
                    arr3[j] = this.equipmentList[i].name
                  } else if (this.equipmentList[i].name == getInfo.equipCodeRoller2nd[j]) {
                    arr3[j] = this.equipmentList[i].name
                  }
                }
                for (let j = 0; j < getInfo.equipCodeRoller3rd.length; j++) {
                  if (this.equipmentList[i].code == getInfo.equipCodeRoller3rd[j]) {
                    arr4[j] = this.equipmentList[i].name
                  } else if (this.equipmentList[i].name == getInfo.equipCodeRoller3rd[j]) {
                    arr4[j] = this.equipmentList[i].name
                  }
                }
              }
              this.workObj.paramInfo.equipCodeList = arr.join("、")
              this.workObj.paramInfo.equipCodePaverStr = arr1.join("、")
              this.workObj.paramInfo.equipCodeRoller1ndStr = arr2.join("、")
              this.workObj.paramInfo.equipCodeRoller2ndStr = arr3.join("、")
              this.workObj.paramInfo.equipCodeRoller3ndStr = arr4.join("、")

              this.workObj.equipCodeList = arr.join("、")
              this.workObj.paramInfo.equipCheckStr = arr.join("、")
              this.workSetInfo_show = this.workObj.paramInfo
              this.workSetInfoShow = true
            }

          }

        }

      })
    }
  },
  components: {
    Parameter, Parameter1
  }
}
</script>

<style lang="scss" scoped="">
.projectInfo {
  width: 98.5%;
  height: auto;
  padding-bottom: 21px;
  margin: 0 auto;
  background-color: #ffffff;
  margin-bottom: 12px;

  .blockHeader {
    width: 100%;
    height: 58px;
    position: relative;

    .workListTable {
      width: 1200px;
      height: 42px;
      position: absolute;
      top: 15px;
      left: 130px;
      // background-color: aquamarine;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;

      .workItem {
        &.activeWorkItem {
          background-color: #e96b5a;

          .workItemText {
            color: #ffffff;
          }
        }

        color: #e96b5a;
        background: #fdf0ef;
        border-color: #f6c4bd;
        height: 32px;
        width: auto;
        display: inline-block;
        line-height: 30px;
        font-size: 14px;

        margin-right: 10px;
        margin-left: 10px;
        // padding: 0 30px;
        vertical-align: top;
        border: 1px solid #e96b5a;
        box-sizing: border-box;
        transform: skewX(-20deg);
        cursor: pointer;

        .workItemText {
          display: inline-block;
          height: 100%;
          width: 100%;
          padding: 0 30px;
          line-height: 30px;
          transform: skewX(20deg);
        }
      }
    }

    .redBlock {
      height: 18px;
      width: 4px;
      position: absolute;
      background-color: #E96B5A;
      top: 19px;
      left: 20px;
    }

    .headerText {
      height: 16px;
      line-height: 16px;
      font-size: 16px;
      color: #222222;
      display: inline-block;
      position: absolute;
      top: 21px;
      left: 34px;
      font-weight: 600;
    }

    .addBtn {
      position: absolute;
      top: 15px;
      right: 191px;
      border-radius: 2px;
    }

    .deleteBtn {
      position: absolute;
      top: 15px;
      right: 15px;
      border-radius: 2px;
    }

    .copyBtn {
      position: absolute;
      top: 15px;
      right: 133px;
      border-radius: 2px;
    }

    .editBtn {
      position: absolute;
      top: 15px;
      right: 75px;
      border-radius: 2px;
    }
  }

  .parameterContent {
    width: 97.7%;
    height: auto;
    margin: 0 auto;
  }

  .blockContent {
    width: 97.7%;
    margin: 0 auto;
    border-top: 1px solid rgba(225, 225, 225, 1);
    border-left: 1px solid rgba(225, 225, 225, 1);

    .blockItem {
      display: flex;
      height: 45px;

      .item_type1 {
        flex: 1;
      }

      .item_type2 {
        flex: 2;
      }

      .itemLeft {
        width: 140px;
        height: 44px;
        float: left;
        background: rgba(242, 242, 245, 1);
        border-bottom: 1px solid rgba(225, 225, 225, 1);
        border-right: 1px solid rgba(225, 225, 225, 1);
        line-height: 44px;
        padding-left: 15px;
        color: #555555;
        font-size: 14px;
      }

      .itemRight {
        // width: 100%;
        height: 44px;
        line-height: 44px;
        padding-left: 18px;
        color: #555555;
        font-size: 14px;

        overflow: hidden;
        border-bottom: 1px solid rgba(225, 225, 225, 1);
        border-right: 1px solid rgba(225, 225, 225, 1);

        .infoShow {
          width: 100%;
          height: 100%;
          border: 0;
          color: #555555;
          font-size: 14px;
        }
      }
    }
  }
}

.lookUp {
  position: fixed;
  right: 85px;
  top: 68px;
  z-index: 100;
}

.goBack {
  position: fixed;
  right: 16px;
  top: 68px;
  z-index: 1000;
}
</style>